import ReactDOM from "react-dom/client";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ConfigProvider } from "antd";
// Antd bundles its OWN dayjs instance (a different physical package from the
// app's root dayjs), which rc-picker's Calendar/DatePicker components use
// internally. Registering both locales on it lets rc-picker's own
// `.locale(...)` call (triggered by LanguageRoot's ConfigProvider locale)
// actually resolve Monday as the first day of the week instead of silently
// no-oping ("en-gb" carries weekStart 1 natively; see LanguageRoot).
import "antd/node_modules/dayjs/locale/id";
import "antd/node_modules/dayjs/locale/en-gb";
import routes from "routes";
import MaintenancePage from "pages/maintenance";
import LanguageRoot from "components/LanguageRoot";
import { theme } from "shared/theme";
import { startVersionWatch } from "shared/utils/appVersion";
import { localizeServerDateLabels } from "shared/utils/serverDateLabels";
import "./i18n";

const queryClient = new QueryClient();
// The server writes these responses' date labels in English; the select puts
// their month names into the admin's language (see serverDateLabels.ts).
for (const queryKey of [["analytics"], ["business", "dashboard"], ["payroll", "settings"]]) {
  queryClient.setQueryDefaults(queryKey, { select: localizeServerDateLabels });
}

const router = createBrowserRouter(routes);

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === "true";

// Production only: in dev the entry script has no content hash, so the check
// would be inert anyway and this keeps a poll out of the dev-server session.
if (process.env.NODE_ENV === "production") startVersionWatch();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  isMaintenanceMode ? (
    <LanguageRoot>
      <ConfigProvider theme={theme}>
        <MaintenancePage />
      </ConfigProvider>
    </LanguageRoot>
  ) : (
    <QueryClientProvider client={queryClient}>
      <LanguageRoot>
        <RouterProvider router={router} />
      </LanguageRoot>
    </QueryClientProvider>
  )
);
